import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../modules/auth';
import { showErrorToast } from 'app/components/ShowToast';

const useTenantCheck = () => {
  const { currentUser,logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.tenantId) {
      showErrorToast({message:'Session expired'});
      navigate('/login');
      logout().catch(error => {
        console.error('Error during logout:', error)
      })
    }
  }, [currentUser, navigate,logout]);
};

export default useTenantCheck;
